import type { FC } from "react";

import { useCheckoutConfiguration } from "@jti/commerce/providers";
import { Typography } from "@jti/ui";

import styles from "./AdditionalInfo.module.scss";

export const AdditionalInfo: FC = () => {
  const { orderSummaryConfig } = useCheckoutConfiguration();
  const { displayAdditionalInfo, additionalInfo } = orderSummaryConfig || {};

  if (!displayAdditionalInfo || !additionalInfo) {
    return null;
  }

  return (
    <div className={styles.container} data-testid="additionalInfo">
      <h4 className={styles.title}>{additionalInfo?.title}</h4>
      <Typography variant="body1" weight="light" className={styles.text}>
        {additionalInfo?.message}
      </Typography>
    </div>
  );
};
